import React from "react";
import { useState, useRef, useEffect, useContext, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import "react-data-table-component-extensions/dist/index.css";
import DataService from ".././../services/tutorial.service";
import "react-confirm-alert/src/react-confirm-alert.css";
//import * as AiIcons from "react-icons/ai";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import Navigationtitle from "../include/Navigationtitle";
//import { Image, Shimmer } from "react-shimmer";
import { BASE_PATH } from ".././../constants/Global";
import { encode } from "base-64";
import { Link } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import { actlistData, actmore, setisfirsttime } from "../../actions/index";
import dateFormat from "dateformat";
import { auctiondefaultLogo, svg } from "../../constants/Images";
import NotFound from "../include/NotFound";
import { FirebaseContext } from '../../FirebaseContext';
import { MdDeleteOutline } from "react-icons/md";

import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faL, faShareNodes } from '@fortawesome/free-solid-svg-icons'
import { faCopy } from '@fortawesome/free-solid-svg-icons'
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { faExpand } from '@fortawesome/free-solid-svg-icons'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
function Auctiondetail(match) {
  const dispatch = useDispatch();
  const loginuser = useSelector((state) => state.setUserlog);
  const history = useHistory({ forceRefresh: true });
  const [data, setData] = useState([]);
  const [path, setPath] = useState([]);
  const [adata, setAData] = useState([]);
  const [pltraid, setpltraid] = useState("");
  const [tmtraid, settmtraid] = useState("");
  const [booster, setbooster] = useState("");
  const [aucback, setaucback] = useState("");
  const [aucbackbox, setaucbackbox] = useState("");
  const [aucstampbox, setaucstampbox] = useState("");
  const [aucustampbox, setaucustampbox] = useState("");
  const [aucsoldstamp, setaucsoldstamp] = useState("");
  const [aucunsoldstamp, setaucunsoldstamp] = useState("");
  const [aucmusic, setaucmusic] = useState("");
  const [aucsponsorbox, setaucsponsorbox] = useState("");
  const [aucbannerbox, setaucbannerbox] = useState("");
  const [aucsponsor, setaucsponsor] = useState("");
  const [aucbanner, setaucbanner] = useState("");
  const [plno, setplno] = useState("");
  const [istfp, setistfp] = useState(false);
  const [istft, setistft] = useState(false);
  const [iscopied, setiscopied] = useState(false);
  const [isActive, setActive] = useState(false);
  const [timertyp, settimertyp] = useState("");
  const [starttime, setstarttime] = useState("");
  const [reftime, setreftime] = useState("");
  const [tempdata, settempdata] = useState("");
  const getpageData = useSelector((state) => state.setactlistData);
  const getpageData2 = useSelector((state) => state.setactlistData);
  const [check1, setcheck1] = useState(false);
  const [isimgpop, setisimgpop] = useState(false);
  const [imgpopdata, setimgpopdata] = useState([]);
  const [aucdetail, setaucdetail] = useState([]);
  const [imgpoptype, setimgpoptype] = useState("");
  const [isbgpop, setisbgpop] = useState(false)
  // const [bnrs, setbnrs] = useState([]);
  // const [aucdetail, setaucdetail] = useState([]);
  const { upddata } = useContext(FirebaseContext);
  const isfirsttime = useSelector((state) => state.isfirsttime);
  const aucmoredetail = useSelector((state) => state.actmoredata);
  const [cid, setCid] = useState(loginuser["cid"]);
  const [token, settoken] = useState(loginuser["token"]);
  const aid = localStorage.getItem("auction_id");
  // const [isbgpop, setisbgpop] = useState(false)
  const [bgdata, setbgdata] = useState([])
  const [isfullbg, setisfullbg] = useState(false)
  const [bgfulldata, setbgfulldata] = useState('')
  const [selectedbgfl, setselectedbgfl] = useState("")

  // const cid = 1;
  // const navigate = useNavigate();
  const fileInputRefs = useRef(Array.from({ length: 8 }, () => React.createRef()));

  const firechange = (datasnap) => {
    if (datasnap.type == "1" && datasnap.upd == "2") {
      console.log("inside auc edit trigger condition")
      if (getpageData != 0) {
        const updateitem = getpageData.responsedata.list.filter(
          (ele, ind) => {
            if (ele.aid == datasnap.id) {
              // console.log()
              ele.logo = datasnap.detail.logo
              ele.type = datasnap.detail.type;
              ele.acttype = datasnap.detail.acttype;
              ele.dt = datasnap.detail.dt;
              ele.atm = datasnap.detail.atm;
              ele.aname = datasnap.detail.aname;
              ele.totalpoint = datasnap.detail.totalpoint;
              ele.unit = datasnap.detail.unit;
              ele.minbid = datasnap.detail.minbid;
              ele.bidup = datasnap.detail.bidup;
              ele.player = datasnap.detail.player;
              ele.minplayer = datasnap.detail.minplayer;
              ele.ses = datasnap.detail.ses;
              setAData(ele)
            }
            return ele;
          }
        );
        localStorage.setItem("auction_name", datasnap.detail.aname);
        let responsedata = {
          responsedata: {
            path: getpageData.responsedata.path,
            cid: cid,
            list: updateitem,
          },
        };
        dispatch(actlistData(responsedata));

      }
    }
    if (datasnap.type == "1" && datasnap.upd == "3") {
      if (getpageData != 0) {
        const updateitem = getpageData.responsedata.list.filter((ele) => ele.aid != datasnap.id)

        let responsedata = {
          responsedata: {
            path: getpageData.responsedata.path,
            cid: cid,
            list: updateitem,
          },
        };
        dispatch(actlistData(responsedata));
      }
      history.push(BASE_PATH + 'my-auction')
    }
    console.log(datasnap)
    if (datasnap.type == "1" && datasnap.upd == "6") {
      console.log(aucdetail)
      if (datasnap.detail.typ == '1') {
        if (datasnap.detail.val == '0') {
          setcheck1(false)
        } else if (datasnap.detail.val == '1') {
          setcheck1(true)
        }
        var auccopy = aucdetail
        auccopy = auccopy.detail.reg_player_on = datasnap.detail.val
        setaucdetail((prev) => ({ ...prev, detail: { ...prev.detail, reg_player_on: datasnap.detail.val } }))
        dispatch(actmore(auccopy));
      }
      if (datasnap.detail.typ == '11') {
        var updateitem = getpageData.responsedata.list.map((ele) => {
          if (ele.aid == aid) {
            ele.istimer = datasnap.detail.val.istimer
            ele.stime = datasnap.detail.val.stime
            ele.rftime = datasnap.detail.val.rftime
          }
          return ele
        })
        let responsedata = {
          responsedata: {
            path: getpageData.responsedata.path,
            cid: cid,
            list: updateitem,
          },
        };
        dispatch(actlistData(responsedata));

        settimertyp(datasnap.detail.val.istimer);
        setstarttime(datasnap.detail.val.stime);
        setreftime(datasnap.detail.val.rftime);
      }
      if (datasnap.detail.typ == '12') {
        var auccopy = aucdetail
        if (auccopy.boost) {

          auccopy.boost = [...auccopy.boost, datasnap.detail.val];
        }
        else {
          auccopy.boost = [datasnap.detail.val];

        }
        // setaucdetail((prev) => ({ ...prev, detail: { ...prev.detail, boost: [datasnap.detail.val] } }))
        dispatch(actmore(auccopy));
      }
      if (datasnap.detail.typ == '13') {
        var auccopy = aucdetail
        auccopy.more[0].bg = datasnap.detail.val.img
        setaucbackbox(auccopy.fpath + datasnap.detail.val.img)

        setaucdetail((prev) => ({ ...prev, more:[{...prev.more,bg:datasnap.detail.val.img}] }))
        console.log(auccopy)
        dispatch(actmore(auccopy));
      }
      if (datasnap.detail.typ == '14') {
        var auccopy = aucdetail
        auccopy.spn = [...auccopy.spn,datasnap.detail.val]
        dispatch(actmore(auccopy));
      }
      if (datasnap.detail.typ == '15') {
        var auccopy = aucdetail
        auccopy.bnr = [...auccopy.bnr,datasnap.detail.val]
        dispatch(actmore(auccopy));
      }
    }



  }

  const deldata = (id) => {
    confirmAlert({
      message: "Are you sure delete this record !",
      buttons: [
        {
          label: "Yes",
          onClick: () => del(id, 1),
        },
        {
          label: "No",
          onClick: () => del(id, 0),
        },
      ],
    });
  };
  const delboostdata = (id) => {
    confirmAlert({
      message: "Are you sure delete this !",
      buttons: [
        {
          label: "Yes",
          onClick: () => delbooster(id),
        },
        {
          label: "No",
        },
      ],
    });
  };
  const delfile = (t) => {
    confirmAlert({
      message: "Are you sure delete this record !",
      buttons: [
        {
          label: "Yes",
          onClick: () => removeuploads(t),
        },
        {
          label: "No",
          // onClick: () => del(id, 0),
        },
      ],
    });
  };
  const del = useCallback(
    async (vl, status) => {
      if (status == 1) {
        setActive(true);

        var hdr = {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: JSON.stringify([{ cid: loginuser["cid"], token: loginuser["token"] }]),
          },
        };

        await DataService.deleteAuction({ aid: encode(vl) }, hdr)
          .then((res) => {
            let response = res.data;
            if (response.success == true) {
              toast.success(response.msg, {
                theme: "dark",
                position: "bottom-center",
              });

              const updateitem = getpageData.responsedata.list.filter(
                (ele, ind) => {
                  if (ele.aid != vl) {
                    return ele;
                  }
                }
              );
              let responsedata = {
                responsedata: {
                  path: getpageData.responsedata.path,
                  cid: cid,
                  list: updateitem,
                },
              };
              dispatch(actlistData(responsedata));
              history.push(BASE_PATH + "my-auction");
              // const updateitem = data.list.filter((ele, ind) => {
              //   return ele.aid != vl;
              // });
              // data.list = updateitem;
              // setData(data);
            } else {
              toast.error(response.msg, {
                theme: "colored",
                position: "bottom-center",
              });
            }

            setActive(false);
          })
          .catch(() => {
            console.log("Not valid");
            toast.error("Not valid Server Error", {
              theme: "colored",
              position: "bottom-center",
            });
            setActive(false);
          });
      }
    },
    [data]
  );
  const fetchdetail = async () => {
    console.log('fetching..')
    setActive(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
      },
    };
    var val = {}
    // val.aid=aid;
    // val.faid = pltraid;
    await DataService.aucdetail(val, hdr)
      .then((res) => {
        console.log("api")

        let response = res.data;
        toast.dismiss(toastContainerId);
        console.log("response")
        console.log(response)

        if (response.success == true) {
          dispatch(actmore(response.data));


          if (response.data.detail.reg_player_on == 1) {
            setcheck1(true)
          }
          console.log(response.data.detail.reg_player_on)
          setaucdetail(response.data)
          console.log(response.data.more)
          if (response.data.more.length > 0) {
            if (response.data.more[0].bg != "") {

              setaucbackbox(response.data.fpath + response.data.more[0].bg)
            }

            if (response.data.more[0].sstamp != "" && response.data.more[0].sstamp != null) {
              setaucstampbox(response.data.fpath + response.data.more[0].sstamp)
            }
            if (response.data.more[0].usstamp != "" && response.data.more[0].usstamp != null) {
              setaucustampbox(response.data.fpath + response.data.more[0].usstamp)
            }
          }

        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }


        setActive(false);
      })
      .catch(() => {
        console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  }
  useEffect(() => {
    window.scrollTo(0, 0);
    console.log(aucmoredetail)
    if (aucmoredetail == 0) {
      fetchdetail();
    }
    else {
      if (aid != aucmoredetail.detail.aid) {
        fetchdetail();
      }
      else {
        if (aucmoredetail.detail.reg_player_on == 1) {
          setcheck1(true)
        }
        console.log(aucmoredetail.detail.reg_player_on)
        setaucdetail(aucmoredetail)
        if (aucmoredetail.more.length > 0) {
          if (aucmoredetail.more[0].bg != "") {

            setaucbackbox(aucmoredetail.fpath + aucmoredetail.more[0].bg)
          }

          if (aucmoredetail.more[0].sstamp != "" && aucmoredetail.more[0].sstamp != null) {
            setaucstampbox(aucmoredetail.fpath + aucmoredetail.more[0].sstamp)
          }
          if (aucmoredetail.more[0].usstamp != "" && aucmoredetail.more[0].usstamp != null) {
            setaucustampbox(aucmoredetail.fpath + aucmoredetail.more[0].usstamp)
          }
        }
      }
    }
    settempdata(localStorage.getItem('myData'))
    const handleBeforeUnload = () => {

    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    localStorage.removeItem('isadel');
    if (getpageData == 0) {
    } else {
      setPath(getpageData.responsedata.path);
      getpageData.responsedata.list.filter((ele, ind) => {
        if (ele.aid == aid) {
          console.log("ele")
          console.log(ele)
          localStorage.setItem("auction_name", ele.aname)
          setAData(ele);
          console.log(ele)
          settimertyp(ele.istimer);
          setstarttime(ele.stime);
          setreftime(ele.rftime);
        }
      });


    }


    return () => {
      localStorage.removeItem('myData');
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);
  useEffect(() => {
    console.log("my upddata");
    console.log(upddata);
    console.log(isfirsttime)
    // console.log(arraysEqual(upddata, isfirsttime))
    if (upddata !== null) {
      if (upddata !== isfirsttime) {
        firechange(upddata);
        if (upddata.type == "1") {
          dispatch(setisfirsttime(upddata));
        }

      }
    }
  }, [upddata]);
  function settfp() {
    if (istfp == false) {
      setistfp(true)

    }

  }
  function settft() {
    if (istft == false) {
      setistft(true)

    }

  }
  const pltransfer = async () => {
    setActive(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
      },
    };
    var val = {}
    // val.aid=aid;
    val.faid = pltraid;
    await DataService.pltransfer(val, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);
        // console.log(response)
        if (response.success == true) {
          // console.log("setted")
          setpltraid("")
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  }
  const tmtransfer = async () => {
    setActive(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
      },
    };
    var val = {}
    // val.aid=aid;
    val.faid = tmtraid;
    console.log(tmtraid)
    await DataService.tmtransfer(val, hdr)
      .then((res) => {
        let response = res.data;
        console.log(response)
        toast.dismiss(toastContainerId);
        // console.log(response)
        if (response.success == true) {
          // console.log("setted")
          settmtraid("")
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  }
  const banneradd = async () => {
    setActive(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });

    var hdr = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
      },
    };
    const formData = new FormData();
    formData.append("bnrimg", aucbanner);

    await DataService.addbanner(formData, hdr)
      .then((res) => {
        let response = res.data;
        console.log(response)
        toast.dismiss(toastContainerId);
        // console.log(response)
        if (response.success == true) {
          setaucbannerbox("")
          fileInputRefs.current.forEach((ref) => {
            if (ref.current) {
              ref.current.value = '';
            }
          });
          setaucdetail(prev => ({
            ...prev,
            bnr: [...prev.bnr, response.data.newentry]
          }))
          // console.log("setted")
          toast.success("Banner Added !!", {
            theme: "colored",
            position: "bottom-center",
          });

          setaucbanner("")
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  }
  const sponsoradd = async () => {
    setActive(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });

    var hdr = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
      },
    };
    const formData = new FormData();
    formData.append("splogo", aucsponsor);
    await DataService.addsponsor(formData, hdr)
      .then((res) => {
        let response = res.data;
        console.log(response)
        toast.dismiss(toastContainerId);
        // console.log(response)
        if (response.success == true) {
          // console.log("setted")
          setaucsponsorbox("")
          fileInputRefs.current.forEach((ref) => {
            if (ref.current) {
              ref.current.value = '';
            }
          });
          toast.success("Sponsor Added !!", {
            theme: "colored",
            position: "bottom-center",
          });

          setaucdetail(prev => ({
            ...prev,
            spn: [...prev.spn, response.data.newentry]
          }))

          setaucsponsor("")
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  }
  const uploadfiles = async (typ) => {
    setActive(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });

    var hdr = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
      },
    };
    const formData = new FormData();
    if (typ == 'bg') {
      console.log(aucback)
      // if (aucbackbox == "") {

      //   formData.append("fl", aucback);
      // } else {
      //   alert('This background is already set !!')
      //   toast.dismiss(toastContainerId); // Dismiss the toast message here

      //   return 0
      // }
      formData.append("fl", aucback);

      console.log("over commimg")
      const fileSizeKB = Math.round(aucback.size / 1024); // Convert bytes to kilobytes
      const fileSizeMB = (fileSizeKB / 1024).toFixed(2); // Convert kilobytes to megabytes
      if (fileSizeMB > 1.25) {
        alert('File size must be less than 1.25Mb')
        toast.dismiss(toastContainerId);
        return 0
      }

    }
    else if (typ == 'sstamp') {
      formData.append("fl", aucsoldstamp);
      const fileSizeKB = Math.round(aucsoldstamp.size / 1024); // Convert bytes to kilobytes
      const fileSizeMB = (fileSizeKB / 1024).toFixed(2); // Convert kilobytes to megabytes
      if (fileSizeMB > 1.25) {
        alert('File size must be less than 1.25Mb')
        toast.dismiss(toastContainerId);
        return 0
      }


    }
    else if (typ == 'usstamp') {
      formData.append("fl", aucunsoldstamp);
      const fileSizeKB = Math.round(aucunsoldstamp.size / 1024); // Convert bytes to kilobytes
      const fileSizeMB = (fileSizeKB / 1024).toFixed(2); // Convert kilobytes to megabytes
      if (fileSizeMB > 1.25) {
        alert('File size must be less than 1.25Mb')
        toast.dismiss(toastContainerId);
        return 0
      }




    }

    formData.append("fltyp", typ);
    console.log(formData)
    await DataService.addfiles(formData, hdr)
      .then((res) => {
        let response = res.data;
        console.log(response)
        toast.dismiss(toastContainerId);
        console.log(response)
        if (response.success == true) {
          if (typ == 'bg') {
            setaucdetail(detail => ({
              ...detail,
              more: [{ ...detail.more[0], bg: response.data.newentry.logo }]
            }))
            setaucback("")

          }
          else if (typ == 'sstamp') {
            console.log('inside sstamp')

            setaucdetail(detail => ({
              ...detail,
              more: [{ ...detail.more[0], sstamp: response.data.newentry.logo }]
            }))
            setaucsoldstamp("")
          }
          else if (typ == 'usstamp') {
            console.log('inside usstamp')
            setaucdetail(detail => ({
              ...detail,
              more: [{ ...detail.more[0], usstamp: response.data.newentry.logo }]
            }))
            setaucunsoldstamp("")
          }
          // console.log("setted")
          fileInputRefs.current.forEach((ref) => {
            if (ref.current) {
              ref.current.value = '';
            }
          });
          toast.success("Added !!", {
            theme: "colored",
            position: "bottom-center",
          });

          // setaucdetail(prev => ({
          //   ...prev,
          //   spn: [...prev.spn, response.data.newentry]
          // }))

        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  }
  var stcls = 'my-acution-top-top-relative';
  var mylblstyle = {

    background: 'white',
  }
  if (adata.status == 1) {

    stcls += ' Sblue';
  }
  else if (adata.status == 3) {

    stcls += ' Syellow';
  }
  else if (adata.status == 5) {

    stcls += ' Sgreen';
  } else {

    stcls += ' Sred';
  }
  function acpgo() {
    document.getElementById('acp1').value = cid;
    document.getElementById('acp2').value = aid;
    document.getElementById('acp3').value = token;
    document.getElementById('acpform').submit();
  }
  function gotocustom() {
    history.push('/join-auction-customization')
  }
  const timerset = async () => {

    setActive(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
      },
    };
    var val = {}
    // val.aid = aid

    val.istimer = timertyp
    val.stime = starttime
    val.rftime = reftime
    await DataService.settimer(val, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);

        if (response.success == true) {
          const updateitem = getpageData.responsedata.list.filter(
            (ele, ind) => {
              if (ele.aid == aid) {
                ele.istimer = timertyp,
                  ele.stime = starttime,
                  ele.rftime = reftime
              }
              return ele;
            }
          )
          let responsedata = {
            responsedata: {
              path: getpageData.responsedata.path,
              cid: cid,
              list: updateitem,
            },
          };
          dispatch(actlistData(responsedata));

          toast.success("Timer Updated !!", {
            theme: "colored",
            position: "bottom-center",
          });
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  };
  const boosterset = async () => {
    setActive(true);
    const id = toast.loading("Please wait...");

    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
      },
    };
    var val = {}
    // val.aid = aid

    val.booster = booster
    val.plno = plno

    console.log(val)
    await DataService.setbooster(val, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);

        if (response.success == true) {
          toast.success("Booster Added !!", {
            theme: "colored",
            position: "bottom-center",
          });
          setaucdetail(prev => ({
            ...prev,

            boost: prev.boost ? [...prev.boost, response.data.newentry] : [response.data.newentry]
          }))
          setbooster("");
          setplno("");

        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  };
  function joinlinkcopy() {
    var linktext = 'https://superplayerauction.com/user/?acode=' + (adata !== "" && adata.acode);
    navigator.clipboard.writeText(linktext);
  }
  const checkhandle = async (t) => {
    // actions.isload(true)

    var x = 0;
    var y;
    if (t == 1) {
      setcheck1(!check1)
      x = document.getElementById('#checkbox').checked;
    }
    if (x == true) {
      y = 1;
    }
    else if (x == false) {
      y = 0;
    }

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
      },
    };
    var val = {}

    val.typ = t
    val.vl = y
    console.log(val)

    console.log(val)
    await DataService.updtrigger(val, hdr)
      .then((res) => {
        let response = res.data;
        // toast.dismiss(toastContainerId);

        if (response.success == true) {
          toast.success("Done !!", {
            theme: "colored",
            position: "bottom-center",
          });

        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });

  }
  function setimagepopup(item, t) {
    setisimgpop(true)
    setimgpopdata(item)
    setimgpoptype(t)
  }
  const removeuploads = async (t) => {
    console.log('under removing..')
    setActive(true);
    const id = toast.loading("Please wait...");

    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
      },
    };
    var vals = {}
    if (t == '1') {
      vals.fltyp = 'bg';
    }
    else if (t == '2') {
      vals.fltyp = 'sstamp';
    }
    else if (t == '3') {
      vals.fltyp = 'usstamp';
    }
    await DataService.delfiles(vals, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);
        console.log(response)

        if (response.success == true) {
          setisimgpop(false)
          if (t == '1') {
            console.log("trigg")
            setaucbackbox("")
            setaucdetail(detail => ({
              ...detail,
              more: [{ ...detail.more[0], bg: "" }]
            }))
          }
          else if (t == '2') {
            setaucstampbox("")
            setaucdetail(detail => ({
              ...detail,
              more: [{ ...detail.more[0], sstamp: "" }]
            }))
          }
          else if (t == '3') {
            setaucustampbox("")
            setaucdetail(detail => ({
              ...detail,
              more: [{ ...detail.more[0], usstamp: "" }]
            }))
          }
          toast.success("Removed !!", {
            theme: "colored",
            position: "bottom-center",
          });

        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  }
  const delbooster = async (i) => {
    console.log('under removing..')
    setActive(true);
    const id = toast.loading("Please wait...");

    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
      },
    };
    var vals = {}

    vals.i = i;
    await DataService.delbooster(vals, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);
        console.log(response)

        if (response.success == true) {
          setaucdetail(detail => ({
            ...detail,
            boost: detail.boost.filter((sp) => sp.bsid != i)
          }))
          toast.success("Removed !!", {
            theme: "colored",
            position: "bottom-center",
          });

        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
  }
  const removefile = async (imgpoptype) => {
    if (imgpoptype == '3' || imgpoptype == '4' || imgpoptype == '5') {
      console.log('under removing..')
      setActive(true);
      const id = toast.loading("Please wait...");

      let toastContainerId = toast.update(id, {
        render: "please wait...",
        theme: "dark",
        position: "bottom-center",
      });
      var hdr = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
        },
      };
      var vals = {}

      if (imgpoptype == '3') {
        console.log('bg')
        vals.fltyp = 'bg';
      }
      else if (imgpoptype == '4') {
        console.log('stamp')

        vals.fltyp = 'sstamp';
      }
      else if (imgpoptype == '5') {
        vals.fltyp = 'usstamp';
      }
      await DataService.delfiles(vals, hdr)
        .then((res) => {
          let response = res.data;
          toast.dismiss(toastContainerId);
          console.log(response)

          if (response.success == true) {
            setisimgpop(false)
            if (imgpoptype == '3') {
              setaucdetail(detail => ({
                ...detail,
                more: [{ ...detail.more[0], bg: "" }]
              }))
            }
            else if (imgpoptype == '4') {
              setaucdetail(detail => ({
                ...detail,
                more: [{ ...detail.more[0], sstamp: "" }]
              }))
            }
            else if (imgpoptype == '5') {
              setaucdetail(detail => ({
                ...detail,
                more: [{ ...detail.more[0], usstamp: "" }]
              }))
            }
            toast.success("Removed !!", {
              theme: "colored",
              position: "bottom-center",
            });

          } else {
            if (response.msg != "")
              toast.error(response.msg, { theme: "colored" });
          }

          setActive(false);
        })
        .catch(() => {
          console.log("Not valid");
          toast.error("Not valid Server Error", { theme: "colored" });
          setActive(false);
        });
    }
    else if (imgpoptype == '2') {
      console.log('under removing..')
      setActive(true);
      const id = toast.loading("Please wait...");

      let toastContainerId = toast.update(id, {
        render: "please wait...",
        theme: "dark",
        position: "bottom-center",
      });
      var hdr = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
        },
      };
      var vals = {}
      vals.i = imgpopdata.spnid

      await DataService.delspn(vals, hdr)
        .then((res) => {
          let response = res.data;
          toast.dismiss(toastContainerId);
          console.log(response)

          if (response.success == true) {
            setisimgpop(false)
            setaucdetail(detail => ({
              ...detail,
              spn: detail.spn.filter((sp) => sp.spnid != imgpopdata.spnid)
            }))
            toast.success("Removed !!", {
              theme: "colored",
              position: "bottom-center",
            });

          } else {
            if (response.msg != "")
              toast.error(response.msg, { theme: "colored" });
          }

          setActive(false);
        })
        .catch(() => {
          console.log("Not valid");
          toast.error("Not valid Server Error", { theme: "colored" });
          setActive(false);
        });
    }
    else if (imgpoptype == '1') {
      console.log('under removing..')
      setActive(true);
      const id = toast.loading("Please wait...");

      let toastContainerId = toast.update(id, {
        render: "please wait...",
        theme: "dark",
        position: "bottom-center",
      });
      var hdr = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
        },
      };
      var vals = {}
      vals.i = imgpopdata.bnrid

      await DataService.delbnr(vals, hdr)
        .then((res) => {
          let response = res.data;
          toast.dismiss(toastContainerId);
          console.log(response)

          if (response.success == true) {
            setisimgpop(false)
            setaucdetail(detail => ({
              ...detail,
              bnr: detail.bnr.filter((bn) => bn.bnrid != imgpopdata.bnrid)
            }))
            toast.success("Removed !!", {
              theme: "colored",
              position: "bottom-center",
            });

          } else {
            if (response.msg != "")
              toast.error(response.msg, { theme: "colored" });
          }

          setActive(false);
        })
        .catch(() => {
          console.log("Not valid");
          toast.error("Not valid Server Error", { theme: "colored" });
          setActive(false);
        });
    }
  }
  const handleFileChange = (e, t) => {
    const file = e.target.files[0];
    if (t == "1") {
      setaucback(file)
    }
    else if (t == "2") {
      setaucsoldstamp(file)
    }
    else if (t == "3") {
      setaucunsoldstamp(file)
    }
    else if (t == "4") {
      setaucsponsor(file)
    }
    else if (t == "5") {
      setaucbanner(file)
    }
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        if (t == "1") {
          setaucbackbox(event.target.result);
        }
        else if (t == "2") {
          setaucstampbox(event.target.result)
        }
        else if (t == "3") {
          setaucustampbox(event.target.result)
        }
        else if (t == "4") {
          setaucsponsorbox(event.target.result)
        }
        else if (t == "5") {
          setaucbannerbox(event.target.result)
        }
      };
      reader.readAsDataURL(file);
    }
  };

  function formlinkcopy(n, c) {
    navigator.clipboard.writeText('You are invited to register yourself for ' + n + 'auction' + '\n' + 'Join from this web link :' + '\n' + 'https://superplayerauction.com/user?acode=' + c + '\n' + 'Join from mobile app :' + '\n' + ' https://superplayerauction.com/view/j/' + c);
    setiscopied(!iscopied)
    setTimeout(function () {
      setiscopied(false)

    }, 1000);

  }
  function hispushform(c) {
    history.push('/?acode=' + c)
  }
  const chooseback = async () => {
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: JSON.stringify([{ cid: cid, token: loginuser["token"] }]),
      },
    };

    await DataService.bglist({}, hdr)
      .then((res) => {
        let response = res.data;
        console.log(response)

        if (response.success == true) {
          setbgdata(response.data)

        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });
    setisbgpop(!isbgpop)

  }
  function showfullbg(ele) {
    setisfullbg(true)
    setbgfulldata(ele)
  }
  function handleDivClick(fl) {
    setselectedbgfl(fl)
  }
  const setbg = async () => {
    setActive(true);
    const id = toast.loading("Please wait...");

    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
      },
    };
    var vals = {}
    vals.fltyp = 'bg';
    vals.fl = selectedbgfl
    await DataService.setbg(vals, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);
        console.log(response)

        if (response.success == true) {
          setisbgpop(false)
          setselectedbgfl("")

          toast.success("Background set !!", {
            theme: "colored",
            position: "bottom-center",
          });
          setaucbackbox(bgdata.path + selectedbgfl)
        } else {
          if (response.msg != "")
            toast.error(response.msg, { theme: "colored" });
        }

        setActive(false);
      })
      .catch(() => {
        console.log("Not valid");
        toast.error("Not valid Server Error", { theme: "colored" });
        setActive(false);
      });

  }
  return (
    <>
      {
        isbgpop &&
        <div id='bgdiv' className="bgdiv">

          <div className="bgpop themeboxmain">
            <div className='headsticky'>
              <h3>Select Background<FontAwesomeIcon onClick={() => { isfullbg ? setisfullbg(false) : setisbgpop(false) }} style={{ position: "relative", float: "right", cursor: 'pointer' }} icon={faXmark} /> </h3>
            </div>
            {!isfullbg && <div className="bgpopmain">
              {bgdata.list.map((ele) => {
                return (
                  <div key={ele.fl} className={`bgimgdiv ${selectedbgfl == ele.fl ? 'selbg' : ''}`} onClick={() => handleDivClick(ele.fl)}>
                    <FontAwesomeIcon onClick={() => showfullbg(ele)} className='imgzoom' icon={faExpand} />
                    <img src={bgdata.path + ele.fl} alt="" />
                    {selectedbgfl == ele.fl && <button onClick={() => setbg()} className='bgsetbtn'>set</button>}

                  </div>
                )
              })}
            </div>}
            {isfullbg &&
              <div className="bgpopmain">
                <img className='bgfullimg' src={bgdata.path + bgfulldata.fl} alt="background" />
              </div>
            }
          </div>
        </div>
      }
      <Navigationtitle data={match} />
      <div>
        <form id="acpform" method='get' action="https://superplayerauction.com/manage/?frnt=1" target="_blank">
          <input type="hidden" id="acp1" name="cid" />
          <input type="hidden" id="acp2" name="aid" />
          <input type="hidden" id="acp3" name="fkey" />
          {/* <input type="hidden" name="loginbyadmin" value="1" /> */}

        </form>
        {isimgpop && <>
          <div className="impopbg"></div>
          <div className="impopmain">
            <div>
              <h3>
                {imgpoptype == "2" && "Sponsor"}
                {imgpoptype == "1" && "Banner"}
                <FontAwesomeIcon onClick={() => setisimgpop(false)} style={{ padding: ".5rem", cursor: "pointer", position: "relative", float: "right" }} icon={faXmark} />
              </h3>

            </div>
            <div>
              {imgpoptype == "2" && <img src={aucdetail.spath + imgpopdata.logo} alt="" />}
              {imgpoptype == "1" && <img src={aucdetail.bpath + imgpopdata.img} alt="" />}
              {imgpoptype == "3" && <img src={aucdetail.fpath + imgpopdata} alt="" />}
              {imgpoptype == "4" && <img src={aucdetail.fpath + imgpopdata} alt="" />}
              {imgpoptype == "5" && <img src={aucdetail.fpath + imgpopdata} alt="" />}


            </div>
            <div onClick={() => removefile(imgpoptype)} style={{ padding: ".5rem", cursor: "pointer", position: "relative", float: "right" }} > <FontAwesomeIcon style={{ marginRight: ".5rem" }} icon={faTrash} />Remove</div>
          </div>

        </>}
        <div
          id="top-categories"
          className="top-cat-area default-padding bottom-less"
        >
          <div className=" nopadd">
            <section className="event-area">
              <span onClick={acpgo} style={{ fontWeight: "bold" }} className="acp">Go to Auction Panel <FontAwesomeIcon className="arright" icon={faArrowRight} /></span>
              <div className="container-fluid nopadd">
                {tempdata}
                {adata != "" ? (
                  <div>
                    <div>
                      <div className="auction-details-top">
                        <div className="auction-details-top-left">
                          {" "}
                          <div className="image-div">
                            <img
                              src={
                                adata.logo == ""
                                  ? auctiondefaultLogo
                                  : path + adata.logo
                              }
                              alt="logo"
                              style={{ height: "70px" }}
                            />
                          </div>
                          <div>
                            <h6 className="auction-heading2">{adata.aname}</h6>
                            <div className="auction-subheading2">
                              A-Code: {adata.acode}
                            </div>
                          </div>
                        </div>

                        <div className="auction-details-display-right">
                          <div className="auction-details-display-right-item">
                            <Link to="/auction-team">
                              {" "}
                              <div>{svg.team}</div>
                              <div className="auction-details-text-color">
                                Team
                              </div>
                            </Link>
                          </div>
                          <div className="auction-details-display-right-item">
                            <Link to="/auction-category">
                              {" "}
                              <div>{svg.category}</div>
                              <div className="auction-details-text-color">
                                Category
                              </div>
                            </Link>
                          </div>
                          <div className="auction-details-display-right-item">
                            <Link to="/auction-players">
                              {" "}
                              <div>{svg.players}</div>
                              <div className="auction-details-text-color">
                                Players
                              </div>
                            </Link>
                          </div>
                          {/* <div className="auction-details-display-right-item">
                            <Link>
                              {" "}
                              <div>{svg.report}</div>
                              <div className="auction-details-text-color">
                                Report
                              </div>
                            </Link>
                          </div> */}
                          <div className="auction-details-display-right-item">
                            <Link to={"/edit-auction/" + encode(aid)}>
                              {" "}
                              <div>{svg.edit}</div>
                              <div className="auction-details-text-color">
                                Edit
                              </div>
                            </Link>
                          </div>
                          <div className="auction-details-display-right-item">
                            <Link onClick={() => deldata(aid)}>
                              {" "}
                              <div>{svg.delete}</div>
                              <div className="auction-details-text-color">
                                Delete
                              </div>
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="myflex">

                        <div className="auction-details-card-container">
                          <div className="auction-details-card-container-top">
                            <div className="auction-details-display-flex">
                              <div className="auction-details-display-left">
                                <div style={{ paddingRight: "5px" }}>
                                  {svg.clender}
                                </div>
                                <div>{dateFormat(adata.dt, "d mmm, yyyy")} &nbsp;&nbsp;{adata.atm}
                                </div>
                              </div>
                              <div className={stcls}>
                                {svg.lblsvg2}

                                <div className="my-acution-top-top-absolute dtsts">
                                  {adata.status == 1 ? "ACTIVE" : adata.status == 3 ? "RUNING" : adata.status == 5 ? "COMPLETED" : "DEACTIVE"}
                                </div>
                              </div>

                            </div>
                          </div>
                          <div className="auction-details-card-container-bottom">
                            <div className="row">
                              <div className="col-xs-12 col-md-6 display-flex detpart padding-bottom">
                                <div className="auction-details-bottom-container-text-left">
                                  Point
                                </div>
                                <div className="auction-details-bottom-container-text-right">
                                  {adata.totalpoint}
                                </div>
                              </div>
                              <div className="col-xs-12 col-md-6 display-flex detpart2  padding-bottom">
                                <div className="auction-details-bottom-container-text-left">
                                  Bid Incr
                                </div>
                                <div className="auction-details-bottom-container-text-right">
                                  {adata.bidup}
                                </div>
                              </div>
                              <div className="col-xs-12 col-md-6 display-flex detpart padding-bottom">
                                <div className="auction-details-bottom-container-text-left">
                                  Basic Bid
                                </div>
                                <div className="auction-details-bottom-container-text-right">
                                  {adata.minbid}
                                </div>
                              </div>
                              <div className="col-xs-12 col-md-6 display-flex detpart2  padding-bottom">
                                <div className="width-25px">
                                  {svg.playerperteam}
                                </div>
                                <div className="auction-details-bottom-container-text-right">
                                  {adata.player} PL/Team
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="auction-details-card-container2 transpl plregfrm">

                          <div className="striphead"><h3>Player Self Registration Form</h3>
                            <div class="pflex1 switchflex">
                              {/* <div>
                                  <label class="form-check-label" for="flexSwitchCheckDefault"> <b>Player can join </b></label>

                                </div> */}
                              <div>
                                <label class="switch">
                                  <input type="checkbox" id="#checkbox" checked={check1} onClick={() => checkhandle(1)} />
                                  <span class="slider round"></span>
                                </label>
                              </div>
                            </div>

                          </div>
                          <div className="pflex1">

                          </div>
                          <div className="plregdiv">
                            <div className="sharediv">

                              <div className="sharemsgbox">
                                <h3><b>Share form link :</b></h3>
                                <p>You are invited to register yourself for the {adata ? adata.aname : 'Auction'} auction</p>
                                <p>Join from web link:</p>
                                <p style={{ cursor: 'pointer' }} onClick={() => hispushform(adata !== "" && adata.acode)} className="regfrmlink">https://superplayerauction.com/user?acode={adata !== "" && adata.acode}</p>
                                <p>Join from the mobile app:</p>
                                <a href={'https://superplayerauction.com/view/j/' + adata !== "" && adata.acode}>  <p style={{ cursor: 'pointer' }} className="regfrmlink">https://superplayerauction.com/view/j/{adata !== "" && adata.acode}</p></a>
                                {/* <p>From Mobile App -</p>
                                <p className="regfrmlink">https://superplayerauction.com/user?acode= {adata !== "" && adata.acode}</p> */}
                                <button onClick={() => formlinkcopy(adata ? adata.aname : 'Auction', adata !== "" && adata.acode)} className="mydesbtn copybtn">{iscopied ? 'Copied' : 'Copy'}</button>
                              </div>
                            </div>
                            <div className="custombox">
                              <h3><b>Customize your form</b></h3>
                              <Link to='join-auction-customization'> <button className="mydesbtn">Customize</button></Link>
                            </div>
                          </div>
                          {/* <div className="plflex">
                            <div className="pflex1">
                              <div class="switchflex">
                                <div>
                                  <label class="form-check-label" for="flexSwitchCheckDefault"> <b>Player can join </b></label>

                                </div>
                                <div>
                                  <label class="switch">
                                    <input type="checkbox" id="#checkbox" checked={check1} onClick={() => checkhandle(1)} />
                                    <span class="slider round"></span>
                                  </label>
                                </div>
                              </div>

                            </div>
                            <div className="sharediv">
                              <div className="sharemsg">
                                <p style={{ fontWeight: 'bold' }}>Join ${ } from Web link :</p>
                                <p className="sharediv" style={{ fontSize: "1.3rem", fontWeight: "bold" }}>https://superplayerauction.com/user/?acode= {adata !== "" && adata.acode} &nbsp; &nbsp; &nbsp;</p>
                              </div>
                              <div className="custombtn">

                              </div>
                            </div>

                          </div> */}
                        </div>

                      </div>
                      <div className="myflex">
                        <div className="auction-details-card-container2 timerflex timerdiv">
                          <div className="timersetting">
                            <div className="striphead"><h3>Timer Setting</h3></div>
                            <div className="strip">
                              <div>
                                <label for="inputPassword4" classname="form-label timelbl">Timer</label>
                              </div>
                              <div className="stripmain">
                                <select id="inputState" value={timertyp} onChange={(e) => settimertyp(e.target.value)} class="form-select">
                                  <option value="0" selected>Off</option>
                                  <option value="1">Auto</option>
                                  <option value="2">Manual</option>
                                </select>
                              </div>
                            </div>
                            <div className="strip">
                              <div>

                                <label for="inputEmail4" class="form-label">Start (sec)</label>
                              </div>
                              <div className="stripmain">

                                <input type="number" class="form-control" value={starttime} onChange={(e) => setstarttime(e.target.value)} id="inputEmail4" />
                              </div>
                            </div>
                            <div className="strip">
                              <div>
                                <label for="inputEmail4" class="form-label">Refresh (sec):</label>&nbsp;&nbsp;&nbsp;

                              </div>
                              <div className="stripmain">

                                <input type="number" class="form-control" value={reftime} onChange={(e) => setreftime(e.target.value)} id="inputEmail4" />
                              </div>
                            </div>
                            <div className="btndiv"><button onClick={() => timerset()} className="mydesbtn timerbtn">Set</button></div>
                          </div>
                        </div>
                        <div className="auction-details-card-container2 timerflex boosterdiv">
                          <div className="boostersetting">
                            <div className="striphead"><h3>Booster Setting</h3></div>
                            <div className="strip strip2 ">
                              <input type="number" class="form-control" value={booster} onChange={(e) => setbooster(e.target.value)} placeholder="Booster" id="inputEmail4" />
                              <label for="inputEmail4" class="form-label hand1 commonlabel">After</label>
                              <input type="number" class="form-control" id="inputEmail4" value={plno} onChange={(e) => setplno(e.target.value)} />
                              <div ><button onClick={() => boosterset()} class="setbtn mydesbtn">ADD</button></div>
                            </div>{
                              (aucdetail != "" && aucdetail.boost) ? aucdetail.boost.map((ele) => {
                                return (
                                  <div className="boosters">Boost<span >{ele.point}</span> after <span>{ele.pl}</span> Players &nbsp;<MdDeleteOutline onClick={() => delboostdata(ele.bsid)} className="boostertrash" />
                                  </div>
                                )
                              }) :
                                <div className="boosternomsg"><p>Currently no booster applied</p></div>
                            }
                          </div>
                        </div>
                      </div>

                      {/* <div className="auction-details-card-container2 timerflex">
                        <div className="tfplayer"><p> Booster setting</p></div>
                        <div className="timerrow timerrow1">

                          <input type="number" class="form-control" value={booster} onChange={(e) => setbooster(e.target.value)} placeholder="Booster" id="inputEmail4" />
                          <label for="inputEmail4" class="form-label hand1">After</label>
                          <input type="number" class="form-control" id="inputEmail4" value={plno} onChange={(e) => setplno(e.target.value)} />
                          <div onClick={() => boosterset()} ><button class="setbtn mydesbtn">ADD</button></div>

                        </div>
                      </div> */}
                      <div className="myflex">
                        <div className="auction-details-card-container2 acardcont3 uploaddiv">
                          <div className="striphead"><h3>Custom Uploads</h3></div>
                          <span className="imglimit">Please upload less than 1.25 Mb image</span>
                          <div className="fileflex">

                            <div className="uploadbox">
                              <div className="newstrip">
                                {aucdetail != "" && aucdetail.more.length > 0 && aucdetail.more[0].bg != "" && aucdetail.more[0].bg != null && aucback == "" &&
                                  <div className="filebtns">
                                    <div> <FontAwesomeIcon onClick={() => { document.getElementById('bg').click(); }} style={{ cursor: 'pointer' }} icon={faPenToSquare} /></div>
                                    <div> <FontAwesomeIcon onClick={() => delfile('1')} style={{ cursor: 'pointer' }} icon={faTrash} /></div>
                                  </div>
                                }
                                <div>
                                  <label className="updlbl" htmlFor="">Background</label>
                                </div>
                                <div style={{ cursor: "pointer" }} className="stripmainbox" onClick={() => { document.getElementById('bg').click(); }}>
                                  {aucbackbox && <img className="boximg" src={aucbackbox} alt="" />}

                                  <label htmlFor="" style={{ cursor: "pointer" }}>+Add</label>
                                  <input className="choosefile" ref={fileInputRefs.current[3]} onChange={(e) => handleFileChange(e, "1")} type="file" id="bg" />
                                </div>
                                <label onClick={() => chooseback()} className="sugbg" style={{ fontSize: '1.2rem', cursor: 'pointer' }} htmlFor="">Suggested Backgrounds</label>


                                {aucback && <div class=""><button onClick={() => uploadfiles('bg')} className="updbtnsnew">Upload</button></div>}

                              </div>

                            </div>
                            <div className="uploadbox">
                              <div className="newstrip">
                                {aucdetail != "" && aucdetail.more.length > 0 && aucdetail.more[0].sstamp != "" && aucdetail.more[0].sstamp != null && aucsoldstamp == "" &&
                                  <div className="filebtns">
                                    <div> <FontAwesomeIcon onClick={() => { document.getElementById('sstamp').click(); }} style={{ cursor: 'pointer' }} icon={faPenToSquare} /></div>
                                    <div> <FontAwesomeIcon onClick={() => delfile('2')} style={{ cursor: 'pointer' }} icon={faTrash} /></div>
                                  </div>
                                }
                                <div>
                                  <label className="updlbl" htmlFor="">Sold Stamp</label>
                                </div>
                                <div style={{ cursor: "pointer" }} className="stripmainbox" onClick={() => { document.getElementById('sstamp').click(); }}>
                                  {aucstampbox && <img className="boximg" src={aucstampbox} alt="" />}

                                  <label htmlFor="" style={{ cursor: "pointer" }}>+Add</label>
                                  <input className="choosefile" ref={fileInputRefs.current[4]} onChange={(e) => handleFileChange(e, "2")} type="file" id="sstamp" />

                                </div>

                                {aucsoldstamp && <div class=""><button onClick={() => uploadfiles('sstamp')} className="updbtnsnew">Upload</button></div>}

                              </div>

                            </div>
                          </div>
                          <div className="fileflex">
                            <div className="uploadbox">
                              <div className="newstrip">
                                {aucdetail != "" && aucdetail.more.length > 0 && (aucdetail.more[0].usstamp != "" && aucdetail.more[0].usstamp != null) && aucunsoldstamp == "" &&
                                  <div className="filebtns">
                                    <div> <FontAwesomeIcon onClick={() => { document.getElementById('usstamp').click(); }} style={{ cursor: 'pointer' }} icon={faPenToSquare} /></div>
                                    <div> <FontAwesomeIcon onClick={() => delfile('3')} style={{ cursor: 'pointer' }} icon={faTrash} /></div>
                                  </div>
                                }
                                <div>
                                  <label className="updlbl" style={{ cursor: "pointer" }} htmlFor="">Unsold Stamp</label>
                                </div>
                                <div style={{ cursor: "pointer" }} className="stripmainbox" onClick={() => { document.getElementById('usstamp').click(); }}>
                                  {aucustampbox && <img className="boximg" src={aucustampbox} alt="" />}

                                  <label htmlFor="">+Add</label>
                                  <input className="choosefile" ref={fileInputRefs.current[5]} onChange={(e) => handleFileChange(e, "3")} type="file" id="usstamp" />

                                </div>

                                {aucunsoldstamp && <div class=""><button onClick={() => uploadfiles('usstamp')} className="updbtnsnew">Upload</button></div>}

                              </div>

                            </div>
                          </div>


                          {/* <div className="strip">
                            <div>

                              <label htmlFor="">Audio Music :</label>
                            </div>
                            <div className="stripmain">

                              <input className="choosefile" value={aucmusic} onChange={(e) => setaucmusic(e.target.value)} type="file" id="inputEmail4" />
                            </div>
                            <div class=""><button onClick={() => sponsoradd()} className="mydesbtn timerbtn">ADD</button></div>

                          </div> */}

                        </div>
                        <div className="auction-details-card-container2 acardcont3 spnbndiv">
                          <div className="striphead"><h3>Sponsors and Banners</h3></div>
                          <div className="bnrsnew">
                            <div className="spnbninp">
                              <div className="new2strip">
                                <div>

                                  <label htmlFor="">Sponsor</label>
                                </div>
                                <div style={{ cursor: "pointer" }} className="spnbnbox" onClick={() => { document.getElementById('spn').click(); }}>
                                  {aucsponsorbox && <img className="boximg" src={aucsponsorbox} alt="" />}

                                  <label style={{ cursor: "pointer" }} htmlFor="">+Add</label>

                                  <div className="stripmain" style={{ display: 'none' }}>
                                    <input className="choosefile" ref={fileInputRefs.current[1]} onChange={(e) => handleFileChange(e, "4")} type="file" id="spn" />
                                  </div>
                                </div>

                                {aucsponsor && <div class=""><button onClick={() => sponsoradd()} className="updbtnsnew">Upload</button></div>}

                              </div>
                            </div>
                            <div className="spnbnimg">
                              {(aucdetail != "" && aucdetail.spn.length > 0) ? aucdetail.spn.map((item) => {
                                return (
                                  <>
                                    <div>
                                      <img onClick={() => setimagepopup(item, "2")} className="" src={aucdetail.spath + item.logo} alt="" />
                                    </div>
                                  </>
                                )
                              })
                                : <><div className="spnbnmsg"> Haven't Uploaded Sponsor !!</div></>

                              }
                            </div>
                          </div>
                          <div className="bnrsnew">
                            <div className="spnbninp">

                              <div className="new2strip">
                                <div>
                                  <label htmlFor="">Banner</label>

                                </div>
                                <div style={{ cursor: "pointer" }} className="spnbnbox" onClick={() => { document.getElementById('bnr').click(); }}>
                                  {aucbannerbox && <img className="boximg" src={aucbannerbox} alt="" />}

                                  <label style={{ cursor: "pointer" }} htmlFor="">+Add</label>

                                  <div className="stripmain" style={{ display: 'none' }}>

                                    <input className="choosefile" ref={fileInputRefs.current[2]} onChange={(e) => handleFileChange(e, "5")} type="file" id="bnr" />

                                  </div>
                                </div>
                                {aucbanner && <div class=""><button onClick={() => banneradd()} className="updbtnsnew">Upload</button></div>}
                              </div>
                            </div>
                            <div className="spnbnimg">
                              {(aucdetail != "" && aucdetail.bnr.length > 0) ? aucdetail.bnr.map((item) => {
                                return (
                                  <>
                                    <div>
                                      <img onClick={() => setimagepopup(item, "1")} className="" src={aucdetail.bpath + item.img} alt="" />
                                    </div>
                                  </>
                                )
                              })
                                : <><div className="spnbnmsg"> Haven't Uploaded Banner !!</div></>
                              }
                            </div>
                          </div>



                        </div>
                      </div>

                      <div className="myflex">
                        <div className="auction-details-card-container2 transpl">
                          <div className="striphead"><h3>Transfer Players From</h3></div>
                          <div className="strip">
                            <label htmlFor="" style={{ fontSize: "14px", fontWeight: "bold" }}>Copy players from previous auctions</label>
                          </div>
                          <div className="strip">

                            <select
                              className="form-control"
                              type="text"
                              value={pltraid}
                              onChange={(e) => setpltraid(e.target.value)}

                            >
                              <option value="" selected>Select Auction</option>
                              {getpageData2?.responsedata?.list.map(
                                (auc) => {
                                  if (auc.aid !== aid) {
                                    return (
                                      <option
                                        value={auc.aid}
                                        key={auc.aid}
                                      >
                                        {auc.aname}
                                      </option>
                                    )
                                  }
                                }
                              )}
                            </select>
                          </div>

                          <div className=""><button className="mydesbtn timerbtn" onClick={pltransfer} >Transfer</button></div>


                        </div>
                        <div className="auction-details-card-container2 transpl">
                          <div className="striphead"><h3>Transfer Teams From</h3></div>
                          <div className="strip">
                            <label htmlFor="" style={{ fontSize: "14px", fontWeight: "bold" }}>Copy teams from previous auctions.</label>
                          </div>
                          <div className="strip">


                            <select
                              className="form-control"
                              type="text"
                              value={tmtraid}
                              onChange={(e) => settmtraid(e.target.value)}
                            >
                              <option value="" selected>Select Auction</option>

                              {getpageData2?.responsedata?.list.map(
                                (auc) => {
                                  if (auc.aid !== aid) {
                                    return (
                                      <option
                                        value={auc.aid}
                                        key={auc.aid}
                                      >
                                        {auc.aname}
                                      </option>
                                    )
                                  }
                                }


                              )}
                            </select>
                          </div>
                          <div ><button className="timerbtn mydesbtn" onClick={tmtransfer}>Transfer</button></div>


                        </div>

                      </div>
                      <div className="myflex">

                      </div>

                      {/* <div onClick={() => gotocustom()} className="auction-details-card-container2">
                        <div className="tfteam"><p> Player Self registration Customization</p></div>

                      </div> */}
                    </div>
                  </div>
                ) : (
                  <NotFound data={isActive} />
                )}
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default Auctiondetail;
